<template>
  <div class="kpi-progress-page">
    <van-tabs
      v-model="typeIndex"
      title-active-color="#3283fa"
      color="#3283fa"
      :line-width="80"
      :sticky="true"
      :swipe-threshold="2"
      @change="setType"
    >
      <van-tab class="list" v-for="(type, key) in types" :key="type.title" :title="type.title">
        <div class="search bottom-line">
          <div class="search-btn">
            <div class="f v">
              <van-search v-model="keyword" placeholder="导购员名称" @search="onSearch"></van-search>
              <van-search v-model="brandName" placeholder="品牌名称" @search="onSearch" class="mt10"></van-search>
            </div>
            <van-button type="info" @click="getQueryStepDetails">搜索</van-button>
          </div>
          <span class="role" @click="getKpiRewardRule">
            奖励规则
            <van-icon name="question-o" />
          </span>
        </div>
        <div class="num bottom-line">
          <span>
            <div>{{stepDetail.staffBonusPool||0}}</div>
            <div>导购员奖金池总额</div>
          </span>
          <span>
            <div>{{stepDetail.totalBean||0}}</div>
            <div>奖励豆总数</div>
          </span>
          <span>
            <div>
              {{stepDetail.fictitiousBean||0}}
              <span class="unit">/个</span>
            </div>
            <div>当前虚拟豆值</div>
          </span>
        </div>
        <div class="num2">
          <span>
            <div>{{stepDetail.actualTotalBean||0}}</div>
            <div>达标奖励豆总数</div>
          </span>
          <span>
            <div>
              {{stepDetail.actualBean||0}}
              <span class="unit">/个</span>
            </div>
            <div>阶段实际豆值</div>
          </span>
        </div>

        <div class="flex bottom-line">
          <span class="tip">已完成任务排行</span>
          <van-button round type="info" size="small" v-if="!completed_show" @click="open(1)">展开</van-button>
          <van-button round type="info" size="small" v-if="completed_show" @click="close(1)">收起</van-button>
        </div>

        <van-list
          v-if="typeIndex === key && completed_show"
          :loading="loading"
          :finished="finished"
          finished-text="— 暂无更多数据 —"
          class="completed"
        >
          <van-cell v-for="(item, key) in alreadyFinishData" :key="key">
            <div class="title">
              <div class="title-left">
                <span class="rank">{{key + 1}}</span>
                <img
                  :src="item.avatar ? item.avatar : 'https://j.weizan.cn/youxiang/images/avatar_default.jpg'"
                  alt
                />
                <div class="column">
                  <!--<div class="user-info"><span class="name">{{item.name}}</span>({{item.brand_name}})</div>-->
                  <div class="name one-nowrap">{{item.kpiUserName}}</div>
                  <!-- <div class="brand one-nowrap" v-if="item.brand_name">(66666)</div>
                  <div class="brand one-nowrap" v-if="item.branch_name">(66666)</div>-->
                  <div class="star-info">
                    <img src="https://j.weizan.cn/youxiang/images/star.png" />
                    <span class="star">奖励豆 {{item.bean}}</span>
                  </div>
                  <div class="income">预计收入 {{item.estimateIncome}}元</div>
                  <div class="income">实际收入 {{item.realIncome}}元</div>
                </div>
              </div>
              <div class="title-right">
                <div class="box">
                  <div class="box-con">
                    <div class="box-text blue">已完成</div>
                  </div>
                </div>​
                <div class="data" v-if="key!==keyId" @click="keyId = key">查看数据</div>
                <div class="data" v-if="key==keyId" @click="keyId = null">收起数据</div>
              </div>
            </div>
            <div v-if="key===keyId" class="achieve">
              <div class="out">
                <div class="in">
                  <div>浏览数量</div>
                  <div>
                    <span>{{item.viewNum}}</span>
                    / {{staffStepVO.viewNum}}
                  </div>
                </div>
                <div class="in">
                  <div>裂变数量</div>
                  <div>
                    <span>{{item.fissionNum}}</span>
                    / {{staffStepVO.fissionNum}}
                  </div>
                </div>
              </div>
              <div class="out">
                <div class="in">
                  <div>报名数量</div>
                  <div>
                    <span>{{item.enrollmentNum}}</span>
                    / {{staffStepVO.enrollmentNum}}
                  </div>
                </div>
                <div class="in">
                  <div>售券数量</div>
                  <div>
                    <span>{{item.cardNum}}</span>
                    / {{staffStepVO.cardNum}}
                  </div>
                </div>
              </div>
              <div class="out">
                <div class="in">
                  <div>秒杀数量</div>
                  <div>
                    <span>{{item.seckillUserNum}}</span>
                    / {{staffStepVO.seckillUserNum}}
                  </div>
                </div>
                <div class="in">
                  <div>集赞数量</div>
                  <div>
                    <span>{{item.thumbNum}}</span>
                    / {{staffStepVO.thumbNum}}
                  </div>
                </div>
              </div>
              <div class="out">
                <div class="in">
                  <div>进入直播间数量</div>
                  <div>
                    <span>{{item.liveViewNum}}</span>
                    / {{staffStepVO.liveViewNum}}
                  </div>
                </div>
                <div class="in">
                  <div>直播下订</div>
                  <div>
                    <span>{{item.liveOrderCusNum}}</span>
                    / {{staffStepVO.liveOrderCusNum}}
                  </div>
                </div>
              </div>
              <div class="out">
                <div class="in">
                  <div>直播自签单</div>
                  <div>
                    <span>{{item.liveSelfOrderNum}}</span>
                    / {{staffStepVO.liveSelfOrderNum}}
                  </div>
                </div>
                <div class="in">
                  <div>直播贡献单</div>
                  <div>
                    <span>{{item.liveOtherOrderNum}}</span>
                    / {{staffStepVO.liveOtherOrderNum}}
                  </div>
                </div>
              </div>
              <div class="out">
                <div class="in">
                  <div>直播自签转单</div>
                  <div>
                    <span>{{item.liveSelfOrderChangeNum}}</span>
                    / {{staffStepVO.liveSelfOrderChangeNum}}
                  </div>
                </div>
                <div class="in">
                  <div>直播贡献转单</div>
                  <div>
                    <span>{{item.liveOtherOrderChangeNum}}</span>
                    / {{staffStepVO.liveOtherOrderChangeNum}}
                  </div>
                </div>
              </div>
              <div class="out">
                <div class="in">
                  <div>过程自签单</div>
                  <div>
                    <span>{{item.processSelfOrderNum}}</span>
                    / {{staffStepVO.processSelfOrderNum}}
                  </div>
                </div>
                <div class="in">
                  <div>过程贡献单</div>
                  <div>
                    <span>{{item.processDevoteOrderNum}}</span>
                    / {{staffStepVO.processDevoteOrderNum}}
                  </div>
                </div>
              </div>
              <div class="out">
                <div class="in">
                  <div>直播预约单</div>
                  <div>
                    <span>{{item.appointmentNum}}</span>
                    / {{staffStepVO.appointmentNum}}
                  </div>
                </div>
                <div class="in">
                </div>
              </div>
            </div>
          </van-cell>
        </van-list>

        <div class="flex bottom-line">
          <span class="tip">未完成任务排行</span>
          <van-button round type="info" size="small" v-if="!incompleted_show" @click="open(0)">展开</van-button>
          <van-button round type="info" size="small" v-if="incompleted_show" @click="close(0)">收起</van-button>
        </div>

        <van-list
          v-if="typeIndex === key && incompleted_show"
          :loading="loading"
          finished-text="— 暂无更多数据 —"
          :finished="finished"
          @load
          class="completed"
        >
          <van-cell v-for="(item, index) in notFinishData" :key="index">
            <div class="title bottom-line">
              <div class="title-left">
                <span class="rank">{{index + 1}}</span>
                <img
                  :src="item.avatar ? item.avatar : 'https://j.weizan.cn/youxiang/images/avatar_default.jpg'"
                  alt
                />
                <div class="column">
                  <div class="name one-nowrap">{{item.kpiUserName}}</div>
                  <!-- <div class="brand one-nowrap" v-if="item.brand_name">({{item.brand_name}})</div>
                  <div class="brand one-nowrap" v-if="item.branch_name">({{item.branch_name}})</div>-->
                  <div class="star-info">
                    <img src="https://j.weizan.cn/youxiang/images/star.png" />
                    <span class="star">奖励豆 {{item.bean}}</span>
                  </div>
                  <div class="income">预计收入 {{item.estimateIncome}}元</div>
                  <div class="income">实际收入 {{item.realIncome}}元</div>
                </div>
              </div>
              <div class="title-right">
                <div class="box">
                  <div class="box-con">
                    <div class="box-text">未完成</div>
                  </div>
                </div>​
                <div class="data" v-if="index!==indexId" @click="indexId = index">查看数据</div>
                <div class="data" v-if="index==indexId" @click="indexId = null">收起数据</div>
              </div>
            </div>
            <div v-if="index===indexId" class="achieve">
              <div class="out">
                <div class="in">
                  <div>浏览数量</div>
                  <div>
                    <span>{{item.viewNum}}</span>
                    / {{staffStepVO.viewNum}}
                  </div>
                </div>
                <div class="in">
                  <div>裂变数量</div>
                  <div>
                    <span>{{item.fissionNum}}</span>
                    / {{staffStepVO.fissionNum}}
                  </div>
                </div>
              </div>
              <div class="out">
                <div class="in">
                  <div>报名数量</div>
                  <div>
                    <span>{{item.enrollmentNum}}</span>
                    / {{staffStepVO.enrollmentNum}}
                  </div>
                </div>
                <div class="in">
                  <div>售券数量</div>
                  <div>
                    <span>{{item.cardNum}}</span>
                    / {{staffStepVO.cardNum}}
                  </div>
                </div>
              </div>
              <div class="out">
                <div class="in">
                  <div>秒杀数量</div>
                  <div>
                    <span>{{item.seckillUserNum}}</span>
                    / {{staffStepVO.seckillUserNum}}
                  </div>
                </div>
                <div class="in">
                  <div>集赞数量</div>
                  <div>
                    <span>{{item.thumbNum}}</span>
                    / {{staffStepVO.thumbNum}}
                  </div>
                </div>
              </div>
              <div class="out">
                <div class="in">
                  <div>进入直播间数量</div>
                  <div>
                    <span>{{item.liveViewNum}}</span>
                    / {{staffStepVO.liveViewNum}}
                  </div>
                </div>
                <div class="in">
                  <div>直播下订</div>
                  <div>
                    <span>{{item.liveOrderCusNum}}</span>
                    / {{staffStepVO.liveOrderCusNum}}
                  </div>
                </div>
              </div>
              <div class="out">
                <div class="in">
                  <div>直播自签单</div>
                  <div>
                    <span>{{item.liveSelfOrderNum}}</span>
                    / {{staffStepVO.liveSelfOrderNum}}
                  </div>
                </div>
                <div class="in">
                  <div>直播贡献单</div>
                  <div>
                    <span>{{item.liveOtherOrderNum}}</span>
                    / {{staffStepVO.liveOtherOrderNum}}
                  </div>
                </div>
              </div>
              <div class="out">
                <div class="in">
                  <div>直播自签转单</div>
                  <div>
                    <span>{{item.liveSelfOrderChangeNum}}</span>
                    / {{staffStepVO.liveSelfOrderChangeNum}}
                  </div>
                </div>
                <div class="in">
                  <div>直播贡献转单</div>
                  <div>
                    <span>{{item.liveOtherOrderChangeNum}}</span>
                    / {{staffStepVO.liveOtherOrderChangeNum}}
                  </div>
                </div>
              </div>
              <div class="out">
                <div class="in">
                  <div>过程自签单</div>
                  <div>
                    <span>{{item.processSelfOrderNum}}</span>
                    / {{staffStepVO.processSelfOrderNum}}
                  </div>
                </div>
                <div class="in">
                  <div>过程贡献单</div>
                  <div>
                    <span>{{item.processDevoteOrderNum}}</span>
                    / {{staffStepVO.processDevoteOrderNum}}
                  </div>
                </div>
              </div>
              <div class="out">
                <div class="in">
                  <div>直播预约单</div>
                  <div>
                    <span>{{item.appointmentNum}}</span>
                    / {{staffStepVO.appointmentNum}}
                  </div>
                </div>
                <div class="in">
                </div>
              </div>
            </div>
          </van-cell>
        </van-list>
      </van-tab>
    </van-tabs>

    <van-popup v-model="show" class="award">
      <img src="https://j.weizan.cn/youxiang/images/awrad_img.jpg" />
      <div class="treaty">
        <div v-html="kpiRewardRule ? kpiRewardRule : '暂无内容'"></div>
      </div>
      <div @click="show = !show" class="close">
        <van-icon name="close" />
      </div>
    </van-popup>

    <div class="home-over-btn">
      <router-link :to="{ name: 'kpi.home', query: { user_id: user_id, kpi_uid: kpi_userid,act_id: activity_id}}">
        <img src="https://j.weizan.cn/youxiang/images/home-over.png"/>
        首页
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activity_id: this.$route.query.act_id || localStorage.getItem("act_id"),
      user_id: localStorage.getItem("user_id"),
      kpi_userid: localStorage.getItem("kpi_user_id") || null,
      activity: {},
      user_id: 0,
      kpi_uid: 0,
      share_uid: 0,
      kpi: {},
      user: null,
      kpi_user: null,
      step_id: null,
      stage: {},
      page: 1,
      loading: false,
      finished: false,
      show: false,
      completed_show: false,
      incompleted_show: false,
      completed: 0,
      typeIndex: 0,
      types: [{ title: "活动池奖金" }],
      list: [],
      keyId: null,
      indexId: null,
      stepDetail: {
        staffBonusPool: 0,
        totalBean: 0,
        fictitiousBean: 0,
        actualTotalBean: 0,
        actualBean: 0,
        rewardRule: "",
      },
      keyword: "",
      brandName: "",
      staffStepVO: {
        viewNum: 0,
        fissionNum: 0,
        enrollmentNum: 0,
        cardNum: 0,
        seckillUserNum: 0,
        thumbNum: 0,
        liveViewNum: 0,
        liveOrderCusNum: 0,
        liveSelfOrderNum: 0,
        liveOtherOrderNum: 0,
        liveSelfOrderChangeNum: 0,
        liveOtherOrderChangeNum: 0,
        processSelfOrderNum: 0,
        processDevoteOrderNum: 0,
        appointmentNum: 0,
      },
      alreadyFinishData: [],
      notFinishData: [],
      avaterurl: "https://j.weizan.cn/youxiang/images/avatar_default.jpg",
      kpiRewardRule: "",
    };
  },
  computed: {
    type() {
      return this.typeIndex + 1;
    },
  },
  created() {
    this.step_id = this.$route.query.step_id;
    this.getQueryStepDetails();
    this.getQueryStepDetail();
    // this.getStage(this.step_id);
    // this.getKpi();
    // this.getUser();
  },
  mounted() {
    this.$initWXSDK(null, () => {
      wx.hideAllNonBaseMenuItem();
    });
  },
  methods: {
    async getQueryStepDetails() {
      var id = this.step_id;
      let res = await this.$http.post(
        `/v1/taskmanage/query_step_detail?stepId=${id}&name=${this.keyword}&brandName=${this.brandName}&`
      );
      console.log(res);
      if (res.data && res.code == 0) {
        this.alreadyFinishData = res.data.alreadyFinishData;
        this.notFinishData = res.data.notFinishData;
        this.stepDetail = res.data;
      }
    },
    // 获取当前阶段导购员任务信息
    async getQueryStepDetail() {
      var id = this.step_id;
      let res = await this.$http.post(
        `/v1/taskmanage/query_step_details?stepId=${id}`
      );
      console.log(res);
      if (res.data && res.code == 0) {
        // this.brandStepVO = res.data.brandStepVO;
        this.staffStepVO = res.data.staffStepVO;
      }
    },
    // 获取奖励规则
    async getKpiRewardRule() {
      let res = await this.$http.post(
        `/v1/taskmanage/query_bonus_setting_detail`
      );
      console.log(res);
      if (res.data && res.code == 0) {
        this.kpiRewardRule = res.data.actKpiVO.rewardRule;
        this.show = true;
      }
    },

    getKpi() {
      this.$fn.get("kpi/settings", { activity_id: this.activity.id }, (res) => {
        this.kpi = res.data;
      });
    },
    setType(index) {
      this.loading = false;
      this.finished = false;
      this.page = 1;
      this.list = [];
      this.keyword = "";
      this.indexId = null;
      this.completed_show = false;
      this.incompleted_show = false;
    },
    /**
     * 任务阶段查询
     * @param id
     */
    getStage(id) {
      this.$fn.showLoading();
      this.$fn.get("steps/" + id, {}, (res) => {
        this.$fn.closeLoading();
        if (res.status === "error") {
          return this.$fn.fail(res.msg);
        }
        this.stage = res.data;
      });
    },
    onSearch() {
      this.getQueryStepDetails();
    },
    /**
     * 奖金池排行
     */
    getList() {
      const json = {
        step_id: this.step_id,
        completed: this.completed,
        page: this.page,
        keyword: this.keyword,
      };
      this.loading = true;
      this.$fn.get("kpi/pool_rank", json, (res) => {
        this.loading = false;
        if (res.status !== "success") {
          this.finished = true;
          return;
        }
        this.list = this.list.concat(res.data);
        if (res.data.length > 0) {
          this.page++;
        }
        if (res.meta.current_page === res.meta.last_page) {
          this.finished = true;
        }
      });
    },
    open(item) {
      this.finished = false;
      this.completed = item;
      if (item === 0) {
        this.incompleted_show = true;
        this.completed_show = false;
        if (this.notFinishData.length == 0) {
          this.finished = true;
        }
      } else if (item === 1) {
        this.completed_show = true;
        this.incompleted_show = false;
        if (this.alreadyFinishData.length == 0) {
          this.finished = true;
        }
      }
      this.loading = false;
      this.page = 1;
      this.list = [];
      // this.getList();
    },
    close(item) {
      if (item === 0) {
        this.incompleted_show = false;
      } else if (item === 1) {
        this.completed_show = false;
      }
    },
    /**
     * 获取用户信息
     */
    getUser() {
      this.$fn.get("user", { activity_id: this.activity.id }, (res) => {
        this.user = res.data;
        this.getKpiUser();
      });
    },
    getKpiUser() {
      this.$fn.get("kpi/user", { activity_id: this.activity.id }, (res) => {
        if (res.status === "success") {
          this.kpi_user = res.data; // type: 3--导购员  type: 2--品牌负责人 type: 1--活动负责人
        }
        this.$fn.commonShare(this.activity, this.user, this.kpi_user);
      });
    },
  },
  filters: {
    /**
     * 四舍五入
     * @param e
     * @returns {*}
     */
    format45(e) {
      if (isNaN(e) || e === undefined || e == null) {
        return 0;
      }
      return Math.round(e * 100) / 100;
    },
  },
};
</script>

<style lang="less" scoped>
.kpi-progress-page {
  .list {
    .search {
      display: flex;
      align-items: center;
      justify-content: space-between;
      background-color: #ffffff;
      margin-top: 10px;
      padding: 12px 10px 12px 15px;
      .search-btn {
        flex: 1;
        display: flex;
        align-items: center;
        /deep/.van-search {
          padding: 0;
          flex: 1;
        }
        /deep/.van-search__content {
          border: 1px solid #dcdcdc;
          background-color: #ffffff;
          padding-left: 0;
          margin-right: 5px;
        }
        /deep/.van-search .van-cell {
          padding: 5px;
        }
        /deep/.van-button {
          flex: 1;
          height: 36px;
          line-height: 34px;
          max-width: 60px;
          border: none;
        }
        /deep/.van-button--normal {
          padding: 0;
        }
      }
      .role {
        margin-left: 5px;
        color: #5293fd;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
      }
    }
    .num {
      display: flex;
      justify-content: space-around;
      text-align: center;
      background-color: #ffffff;
      padding: 10px 15px;
      line-height: 23px;
      span {
        width: 33%;
        border-right: 1px solid #f4f4f4;
      }
      span:last-child {
        border: none;
      }
      div:first-child {
        color: #5293fd;
        font-size: 16px;
      }
      div:last-child {
        color: #999999;
        font-size: 12px;
      }
      .unit {
        font-size: 12px;
      }
    }
    .num2 {
      display: flex;
      justify-content: space-around;
      text-align: center;
      background-color: #ffffff;
      padding: 10px 15px;
      line-height: 23px;
      span {
        width: 33%;
      }
      span:last-child {
        border: none;
      }
      div:first-child {
        color: #5293fd;
        font-size: 16px;
      }
      div:last-child {
        color: #999999;
        font-size: 12px;
      }
      .unit {
        font-size: 12px;
      }
    }
  }
  .flex {
    padding: 10px 15px;
    background-color: #ffffff;
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    .tip {
      font-weight: bold;
    }
  }
  /deep/.van-button--small {
    height: 24px;
    line-height: 22px;
  }
  .completed {
    /*已完成*/
    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      .title-left {
        display: flex;
        align-items: center;
        padding: 10px 0 10px 10px;
        overflow: hidden;
        flex: 1;
        .rank {
          /*排行*/
          text-align: center;
          min-width: 25px;
          max-width: 25px;
          height: 25px;
          line-height: 23px;
          border-radius: 50%;
          background-color: #1986ff;
          border: 2px solid #aedaff;
          color: #ffffff;
          box-sizing: border-box;
        }
        img {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          margin: 0 5px;
          flex-shrink: 0;
        }
        .column {
          display: flex;
          flex-direction: column;
          flex: 1;
          .one-nowrap {
            line-height: 18px;
          }
          .name {
            font-weight: bold;
          }
          .brand {
            font-size: 13px;
          }
          .star-info {
            display: flex;
            align-items: center;
            img {
              width: 15px;
              height: 15px;
              border-radius: 0;
              position: relative;
              top: -1px;
              margin: 0;
              flex-shrink: 0;
            }
            .star {
              color: #f58022;
              margin: 0 3px;
              font-size: 12px;
            }
            .income {
              color: #666666;
              font-size: 12px;
            }
          }
          .income {
            color: #666666;
            font-size: 12px;
            line-height: 18px;
          }
        }
      }
      .title-right {
        width: 70px;
        .box {
          position: absolute;
          height: 100%;
          top: 42px;
          right: 62px;
          .box-con {
            position: absolute;
            width: 90px;
          }
          .box-text {
            color: #808080;
            background-color: #e0e0e0;
            text-align: center;
            font-size: 12px;
            line-height: 16px;
            -webkit-transform: rotate(35deg);
            -moz-transform: rotate(35deg);
            -ms-transform: rotate(35deg);
            -o-transform: rotate(35deg);
            position: relative;
            left: -5px;
            top: -32px;
          }
          .blue {
            color: #5293fd;
            background-color: #dbefff;
          }
          .box-text:before,
          .box-text:after {
            content: "";
            position: absolute;
            bottom: -3px;
          }
          .box-text:after {
            right: 0;
          }
          .box-text:before {
            left: 0;
          }
        }
        .data {
          /*查看数据*/
          color: #5293fd;
          font-size: 12px;
          padding-right: 15px;
          position: absolute;
          bottom: 10px;
        }
      }
    }
    .achieve {
      /*展开详情*/
      font-size: 12px;
      .out {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex: 1;
        padding: 5px 0;
        width: 100%;
        .in {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 10px;
          min-width: 40%;
          span {
            color: #5293fd;
          }
          input {
            max-width: 40px;
            box-sizing: border-box;
          }
          input:focus {
            background-color: #fafafa;
            border-radius: 2px;
            outline: none;
          }
        }
      }
    }
  }
  /deep/.van-cell {
    padding: 0;
  }

  /deep/.van-popup {
    background-color: transparent;
  }
  .award {
    /*奖励规则弹框*/
    width: 70%;
    overflow: hidden;
    img {
      border-radius: 4px 4px 0 0;
      width: 100%;
      height: 60px;
      vertical-align: bottom;
      border-radius: 4px 4px 0 0;
    }
    .treaty::-webkit-scrollbar {
      display: none;
    }
    .treatyContent::-webkit-scrollbar {
      display: none;
    }
    .treaty {
      overflow-x: hidden;
      max-height: calc(50vh);
      min-height: calc(20vh);
      background-color: #ffffff;
      border-radius: 0 0 4px 4px;
      padding: 10px;
    }
    .treaty /deep/ img {
      max-width: 100%;
    }
    .close {
      color: #ffffff;
      margin-top: 10px;
      text-align: center;
      font-size: 26px;
    }
  }
}
</style>
